export default __webpack_public_path__ + "static/media/FG_55.6f60dde2.jpg";